export default "__VITE_ASSET__BcjI0F8W__"